import React, { useState } from 'react';

import { Button } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  AbilityScoresUpgradable,
  Creature,
  Summon,
  UpgradableNumber,
} from "@dndModels";

import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import StringBox from "@components/input/strings/StringBox";

interface Props {
  obj: Creature | Summon;
  onChange: (changed: AbilityScoresUpgradable) => void;
  disabled?: boolean;
}

export default function CreatureAbilityScoresUpgradableInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [ping, setPing] = useState(false);
  const [view, setView] = useState("Ability Scores");
  const [parse_string, setParseString] = useState("");

  const parse = () => {
    const new_obj = obj;
    const parsed = JSON.parse(parse_string);
    if (typeof parsed === "object") {
      // console.log(parsed);
      new_obj.ability_scores.setAbilityScore("strength", new UpgradableNumber(parsed.strength));
      new_obj.ability_scores.setAbilityScore("dexterity", new UpgradableNumber(parsed.dexterity));
      new_obj.ability_scores.setAbilityScore("constitution", new UpgradableNumber(parsed.constitution));
      new_obj.ability_scores.setAbilityScore("intelligence", new UpgradableNumber(parsed.intelligence));
      new_obj.ability_scores.setAbilityScore("wisdom", new UpgradableNumber(parsed.wisdom));
      new_obj.ability_scores.setAbilityScore("charisma", new UpgradableNumber(parsed.charisma));
      onChange(new_obj.ability_scores);
      setPing(!ping);
    }
  }

  const renderUpgradableNumberBox = (ability: string) => {
    let ability_score: UpgradableNumber = new UpgradableNumber();
    switch(ability) {
      case "Strength":
        ability_score = obj.ability_scores.strength;
      break;
      case "Dexterity":
        ability_score = obj.ability_scores.dexterity;
      break;
      case "Constitution":
        ability_score = obj.ability_scores.constitution;
      break;
      case "Intelligence":
        ability_score = obj.ability_scores.intelligence;
      break;
      case "Wisdom":
        ability_score = obj.ability_scores.wisdom;
      break;
      case "Charisma":
        ability_score = obj.ability_scores.charisma;
      break;
    }

    return (
      <UpgradableNumberBox
        name={ability}
        value={ ability_score }
        disabled={disabled}
        attached_table={obj instanceof Creature ? obj.table : undefined}
        onChange={(changed: UpgradableNumber) => {
          const ability_scores = obj.ability_scores;
          switch(ability) {
            case "Strength":
              ability_scores.strength = changed;
            break;
            case "Dexterity":
              ability_scores.dexterity = changed;
            break;
            case "Constitution":
              ability_scores.constitution = changed;
            break;
            case "Intelligence":
              ability_scores.intelligence = changed;
            break;
            case "Wisdom":
              ability_scores.wisdom = changed;
            break;
            case "Charisma":
              ability_scores.charisma = changed;
            break;
          }
          console.log(changed);
          console.log(ability_scores);
          onChange(ability_scores);
          setPing(!ping);
        }}
      />
    );
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <CenteredMenu
          options={["Ability Scores", "Parse"]}
          selected={view}
          onSelect={setView}
        />
      </Grid>
      { view === "Ability Scores" ?
        <>
          <Grid
            className="header"
            size={{
              xs: 12
            }}>
            Ability Scores
          </Grid>
          <Grid
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 4
              }}>
              { renderUpgradableNumberBox("Strength") }
            </Grid>
            <Grid
              size={{
                xs: 4
              }}>
              { renderUpgradableNumberBox("Dexterity") }
            </Grid>
            <Grid
              size={{
                xs: 4
              }}>
              { renderUpgradableNumberBox("Constitution") }
            </Grid>
            <Grid
              size={{
                xs: 4
              }}>
              { renderUpgradableNumberBox("Intelligence") }
            </Grid>
            <Grid
              size={{
                xs: 4
              }}>
              { renderUpgradableNumberBox("Wisdom") }
            </Grid>
            <Grid
              size={{
                xs: 4
              }}>
              { renderUpgradableNumberBox("Charisma") }
            </Grid>
          </Grid>
        </>
      :
        <>
          <Grid
            size={{
              xs: 9
            }}>
            <StringBox 
              name="Parser"
              value={parse_string}
              multiline
              onBlur={(changed: string) => {
                while (changed.includes("–")) {
                  changed = changed.replace("–","-");
                }
                setParseString(changed);
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 3
            }}>
            <Button variant="contained" color="primary" disabled={disabled}
              onClick={parse}>
              Parse
            </Button>
          </Grid>
        </>
      }
    </Grid>
  );
}
